import { weAllTeamMessage } from "../libs/api-url";
import axios from "@/libs/axios";

/**
 * WeAll Team Messages Service - admin <-> app user direct messages, all sent as the "WeAll Team" account.
 *
 * API Endpoints (under /api/v1/admin/weall-team-messages):
 * - GET  /users         - search app users to message
 * - POST /send          - message a user (starts the conversation)
 * - POST /reply         - reply in a conversation
 * - GET  /inbox         - conversations, newest first, with unread counts
 * - GET  /conversation  - history of one conversation (opening page 1 marks it read)
 * - GET  /unread-count  - total unread (sidebar badge)
 */
class WeAllTeamService {
  static async searchUsers(search = "", page = 1) {
    const response = await axios.get(weAllTeamMessage.users, {
      params: { page, ...(search ? { search } : {}) },
    });
    return response.data;
  }

  // With a file the request is multipart (the axios interceptor encrypts the text fields and leaves the file as-is).
  // The content type must be set explicitly, or axios turns the FormData into JSON.
  static buildRequest(fields, file) {
    if (!file) return [fields];
    const form = new FormData();
    Object.entries(fields).forEach(([key, value]) =>
      form.append(key, value ?? ""),
    );
    form.append("file", file);
    return [form, { headers: { "Content-Type": "multipart/form-data" } }];
  }

  static async send({ user_uuid, message, file }) {
    const response = await axios.post(
      weAllTeamMessage.send,
      ...this.buildRequest({ user_uuid, message }, file),
    );
    return response.data;
  }

  static async reply({ conversation_id, message, file }) {
    const response = await axios.post(
      weAllTeamMessage.reply,
      ...this.buildRequest({ conversation_id, message }, file),
    );
    return response.data;
  }

  static async getInbox(params = {}) {
    const response = await axios.get(weAllTeamMessage.inbox, { params });
    return response.data;
  }

  static async getConversation(params) {
    const response = await axios.get(weAllTeamMessage.conversation, {
      params,
    });
    return response.data;
  }

  static async getUnreadCount() {
    const response = await axios.get(weAllTeamMessage.unreadCount);
    return response.data;
  }
}

export default WeAllTeamService;
